export const uk = {
    collapse: 'Свернуть',
    expand: 'Развернуть'
};
